import { createContext } from 'react';

export type AgreePADCtx = {
  showAgreePADSuccessAlert: boolean;
};

const AgreePADContext = createContext<AgreePADCtx>({
  showAgreePADSuccessAlert: false,
});

export default AgreePADContext;
